import { useEffect, useState } from 'react'

/**
 * Returns the current time in milliseconds, refreshed every `intervalMs` while `enabled` is true.
 * Used to advance time-based displays (such as a running health check) between data refreshes.
 */
export function useNow(intervalMs: number, enabled: boolean): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!enabled) {
      return
    }

    setNow(Date.now())
    const timer = setInterval(() => { setNow(Date.now()) }, intervalMs)
    return () => { clearInterval(timer) }
  }, [intervalMs, enabled])

  return now
}
